module.exports = __webpack_public_path__ + "static/media/detail_0046_f.6bafb820.jpg";